import { useState, useEffect } from 'react';
import { API_CONFIG } from './../../config';

const APPITEMSUSEFETCH = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.APPITEMSUSEFETCH}`;


const UseAppItemsUse = () => {
    const [appitemsuse, setAppitemsuse] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(APPITEMSUSEFETCH);
                if (!response.ok) throw new Error('Network response was not ok');

                const data = await response.json();
                if (data.success) {
                    setAppitemsuse(data.data || []);
                }
            } catch (err) {
                console.error("Fetch users error:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, []);

    // Returning data and loading state just like your book example
    return { appitemsuse, loading };
};

export default UseAppItemsUse;